module.exports = __webpack_public_path__ + "img/close-L.db4514fc.svg";